export const PREVIEW_PLACEHOLDERS = [
    'offer_name',
    'offer_id',
    'photos_count',
    'videos_count',
    'photos_array',
    'rating',
    'positive',
    'negative',
    'comment',
];

export const DEFAULT_PREVIEW_PROMPT = [
    'Пользователь заказал товар: {offer_name}',
    'Артикул товара: {offer_id}',
    'Количество фото: {photos_count}',
    'Количество видео: {videos_count}',
    'Фотографии: {photos_array}',
    'Оценка: {rating}',
    'Достоинства: {positive}',
    'Недостатки: {negative}',
    'Текст отзыва: {comment}',
].join('\n');

export function reviewPromptValues(review) {
    const source = review || {};
    const product =
        source.product && typeof source.product === 'object' ? source.product : {};
    const text = source.text;
    let comment = '';
    let positive = '';
    let negative = '';
    if (text && typeof text === 'object') {
        comment = text.comment || '';
        positive = text.positive || '';
        negative = text.negative || '';
    } else if (text != null) {
        comment = String(text);
    }

    const photos = Array.isArray(source.photos) ? source.photos : [];
    const urls = photos
        .map((item) => {
            if (typeof item === 'string') return item;
            return item?.url || item?.preview_url || '';
        })
        .filter(Boolean);
    const videos = Array.isArray(source.videos) ? source.videos : [];
    const asInt = (value) => {
        const number = Number(value);
        return Number.isFinite(number) ? number : 0;
    };

    return {
        offer_name: product.name || product.title || source.product_name || '',
        offer_id: product.offer_id || '',
        photos_count: Math.max(
            asInt(source.photos_count),
            asInt(source.photos_amount),
            urls.length,
            photos.length
        ),
        videos_count: Math.max(
            asInt(source.videos_count),
            asInt(source.videos_amount),
            videos.length
        ),
        photos_array: urls.join(', '),
        photo_urls: urls,
        rating: source.rating != null ? source.rating : 0,
        positive,
        negative,
        comment,
    };
}

export function fillPreviewPrompt(prompt, values) {
    const mapping = {};
    PREVIEW_PLACEHOLDERS.forEach((key) => {
        mapping[key] = values?.[key] == null ? '' : String(values[key]);
    });
    return String(prompt || DEFAULT_PREVIEW_PROMPT).replace(/\{([a-z_]+)\}/g, (full, key) =>
        Object.prototype.hasOwnProperty.call(mapping, key) ? mapping[key] : full
    );
}

export function combineGenerationPrompt(preview, main, values) {
    const filled = fillPreviewPrompt(preview || DEFAULT_PREVIEW_PROMPT, values).trim();
    const mainText = String(main || '').trim();
    return [filled, mainText].filter(Boolean).join('\n\n');
}
